let Brands = {
  Names: {
    Unknown: 'unknown',
    Amex: 'amex',
    Diners: 'diners',
    Discover: 'discover',
    JCB: 'jcb',
    Mastercard: 'mastercard',
    Maestro: 'maestro',
    Visa: 'visa',
  },
};

Brands.CardBrands = {
  [Brands.Names.Visa]: {
    brand: Brands.Names.Visa,
    brandPattern: /^4.*$/,
    cardPattern: /^4\d*$/,
    spaces: [4, 8, 12],
    lengths: [13, 16, 18, 19],
    cvvLength: 3,
  },
  [Brands.Names.Mastercard]: {
    brand: Brands.Names.Mastercard,
    brandPattern: /^(5[1-5]|2[2-7]).*$/,
    cardPattern: /^(5[1-5]|222[1-9]|2[3-6]|27[0-1]|2720)\d*$/,
    spaces: [4, 8, 12],
    lengths: [16],
    cvvLength: 3,
  },
  [Brands.Names.Amex]: {
    brand: Brands.Names.Amex,
    brandPattern: /^(34|37).*$/,
    cardPattern: /^3[47]\d*$/,
    spaces: [4, 10],
    lengths: [15],
    cvvLength: 4,
  },
  [Brands.Names.Diners]: {
    brand: Brands.Names.Diners,
    brandPattern: /^(3[0689]).*$/,
    cardPattern: /^3(0[0-5]|[689])\d*$/,
    spaces: [4, 10],
    lengths: [14],
    cvvLength: 3,
  },
  [Brands.Names.Discover]: {
    brand: Brands.Names.Discover,
    brandPattern: /^(60|64|65|622).*$/,
    cardPattern: /^(6011|65|64[4-9])\d*$/,
    spaces: [4, 8, 12],
    lengths: [16],
    cvvLength: 3,
  },
  [Brands.Names.JCB]: {
    brand: Brands.Names.JCB,
    brandPattern: /^(18|21|35).*$/,
    cardPattern: /^(2131|1800|35)\d*$/,
    spaces: [4, 8, 12],
    lengths: [16],
    cvvLength: 3,
  },
  [Brands.Names.Maestro]: {
    brand: Brands.Names.Maestro,
    brandPattern: /^(5[06-9]|6[237])\d*$/,
    cardPattern: /^(5[06-9]|6[237])\d*$/,
    spaces: [4, 8, 12],
    lengths: [12, 13, 14, 15, 16, 17, 18, 19],
    cvvLength: 3,
  },
  [Brands.Names.Unknown]: {
    brand: Brands.Names.Unknown,
    brandPattern: /^.*$/,
    cardPattern: /^.\d$/,
    spaces: [4, 8, 12],
    lengths: [19],
    cvvLength: 4,
  },
};

Brands.cardBrand = function (cardNumber) {
  cardNumber = cardNumber ? cardNumber.toString().replace(/\s/g, '') : '';

  for (let brandName in Brands.CardBrands) {
    let cardBrand = Brands.CardBrands[brandName];

    if (cardBrand.brandPattern.test(cardNumber)) {
      return cardBrand;
    }
  }
  return Brands.CardBrands[Brands.Names.Unknown];
};

Brands.cardBrandByName = function (brandName) {
  let brand = Brands.CardBrands[brandName];
  if (brand) {
    return brand;
  }
  return Brands.CardBrands[Brands.Names.Unknown];
};

module.exports = Brands;



// WEBPACK FOOTER //
// ./app/brands.js